enum ESnackBarPosition {
  TOP = 0,
  BOTTOM = 1,
}

export default ESnackBarPosition;
